import { useQuery } from 'react-query';
import { statsByDayQuery } from './useStatsByDay.query';
import { UseStatsByDayOptions } from './useStatsByDay.types';
import {
  StatsByDayRequestData,
  StatsResultsResponseRow,
} from '../../../types/api/endpoints/stats/results.types';

export const STATS_RESULTS_BY_DAY_QUERY_KEY = 'STATS_RESULTS_BY_DAY';

export const useStatsByDay = (data: StatsByDayRequestData, options?: UseStatsByDayOptions) => {
  return useQuery<StatsResultsResponseRow[], Error>(
    [STATS_RESULTS_BY_DAY_QUERY_KEY, data],
    () => statsByDayQuery(data),
    options
  );
};
